var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99998 1.99984V3.33317H2.66665V12.6665H13.3333V6.6665H14.6666V13.3332C14.6666 13.51 14.5964 13.6796 14.4714 13.8046C14.3464 13.9296 14.1768 13.9998 14 13.9998H1.99998C1.82317 13.9998 1.6536 13.9296 1.52858 13.8046C1.40355 13.6796 1.33331 13.51 1.33331 13.3332V2.6665C1.33331 2.48969 1.40355 2.32012 1.52858 2.1951C1.6536 2.07008 1.82317 1.99984 1.99998 1.99984H5.99998ZM10.6666 3.33317V0.666504L15.3333 4.6665H9.33331C8.97969 4.6665 8.64055 4.80698 8.3905 5.05703C8.14046 5.30708 7.99998 5.64621 7.99998 5.99984V9.99984H6.66665V5.99984C6.66665 5.29259 6.9476 4.61432 7.44769 4.11422C7.94779 3.61412 8.62607 3.33317 9.33331 3.33317H10.6666Z",
    fill: "#484B54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionSend);
export default __webpack_public_path__ + "static/media/action-send.12f89ecbc716eb3e7fddcabfa211638b.svg";
export { ForwardRef as ReactComponent };